import { FeatureDetail } from '../platform-api/__generated__/graphql';

// Supported features meaning they have an icon
enum SupportedFeatures {
  hot_tub = 'Hot Tub',
  communal_pool = 'Communal Pool',
  fitness_room = 'Fitness Room',
  garage = 'Garage',
  golf = 'Golf',
  grill = 'Grill',
  parking = 'Parking',
  dvd = 'Dvd',
  ac = 'Air Conditioning',
  no_ac = 'No Air Conditioning',
  dryer = 'Dryer',
  internet = 'Internet',
  linens = 'Linens',
  living_room = 'Living Room',
  telephone = 'Telephone',
  towels = 'Towels',
  washer = 'Washer',
  cable = 'Satellite or Cable',
  stereo = 'Stereo',
  television = 'Television',
  coffeemaker = 'Coffeemaker',
  dishes_utensils = 'Dishes & Utensils',
  dishwasher = 'Dishwasher',
  kitchen = 'Kitchen',
  microwave = 'Microwave',
  oven = 'Oven',
  refrigerator = 'Refrigerator',
  pantry_items = 'Pantry Items',
  stove = 'Stove',
  toaster = 'Toaster',
  balcony = 'Balcony',
  tennis = 'Tennis',
  heating = 'Heating',
  steps_to_sand = 'Steps to Sand',
  spa = 'Spa',
  poolside_bar = 'Poolside Bar',
  shuffleboard = 'Shuffleboard Court',
  onsite_dining = 'Onsite Dining',
  fire_pit = 'Fire Pit',
  ceiling_fan = 'Ceiling Fan',
}

// Add icons routes here. Path should be relative to public folder
const createFeatureIconURL = (name: string) =>
  !SupportedFeatures[name as keyof typeof SupportedFeatures]
    ? '/image/features/default.svg'
    : `/image/features/${name}.svg`;

// Priority order of features
//? Should this be in brand config?
const PriorityOrder = [
  SupportedFeatures.hot_tub,
  SupportedFeatures.fitness_room,
  SupportedFeatures.communal_pool,
  SupportedFeatures.garage,
  SupportedFeatures.golf,
  SupportedFeatures.grill,
  SupportedFeatures.parking,
];

// Derive the enum keys from PriorityOrder for sorting by feature.value
const PriorityOrderKeys = PriorityOrder.map((displayValue) => {
  const entry = Object.entries(SupportedFeatures).find(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([key, value]) => value === displayValue
  );
  return entry![0];
});

/**
 *
 * @param orderArray Priority order of features
 * @param arrayToSort Array of features to sort
 * @returns Sorted array of features
 */
function sortObjectsByOrder(
  orderArray: string[],
  arrayToSort: FeatureDetail[]
): FeatureDetail[] {
  return arrayToSort.sort((a, b) => {
    const indexA = PriorityOrderKeys.indexOf(a.value);
    const indexB = PriorityOrderKeys.indexOf(b.value);

    // If both elements are found in orderArray, sort by their indexes
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    // If only element a is found, it comes before element b
    if (indexA !== -1) {
      return -1;
    }
    // If only element b is found, it comes before element a
    if (indexB !== -1) {
      return 1;
    }
    // If neither is found, keep original order
    return 0;
  });
}

export const buildSortedFeatures = (
  features: FeatureDetail[],
  max?: number
) => {
  const sortedFeatures = sortObjectsByOrder(PriorityOrder, features);
  const limitedFeatures =
    max !== undefined ? sortedFeatures.slice(0, max) : sortedFeatures;
  return limitedFeatures.map((feature) => {
    return {
      name:
        SupportedFeatures[feature.value as keyof typeof SupportedFeatures] ||
        feature.name,
      icon: createFeatureIconURL(feature.value),
      detail: feature.detail,
      category: feature.category,
      value: feature.value,
    };
  });
};
